<template>
  <div class="modal-overlay" v-if="visible" @click.self="close">
    <div class="modal-box">
      <div class="modal-header">
        <div class="modal-title">{{ $t('legacy.Точно удалить?') }}</div>
      </div>
      <button class="close-button" @click="close">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M18 6L6 18" stroke="#7A8A99" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
          <path d="M6 6L18 18" stroke="#7A8A99" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
      </button>
      <div class="actions">
        <button @click="clearContent" class="btn primary">{{ $t('common.delete') }}</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    visible: Boolean,
  },
  methods: {
    close() {
      this.$emit('close');
    },

    clearContent() {
      this.$emit('clear-content');
    },
  },
};
</script>

<style scoped>

@keyframes modal-appear {
        from {
                opacity: 0;
                transform: translateY(20px);
        }

        to {
                opacity: 1;
                transform: translateY(0);
        }
}

.modal-overlay {
  position: fixed;
  inset: 0;
  background-color: rgba(0, 0, 0, 0.3);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 10000;
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 24px;
}

.modal-title {
  font-size: 18px;
  font-weight: 600;
  color: #26374e;
  margin: 0;
  line-height: 1.4;
}

.actions {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.btn {
  background-color: #496782;
        color: white;
        border: none;
        border-radius: 8px;
        padding: 12px 24px;
        font-size: 14px;
        font-weight: 600;
        text-transform: uppercase;
        cursor: pointer;
        transition: background-color 0.2s;
        width: 100%;
}

.primary {
  background-color: #3b5b75;
  color: white;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.primary:hover {
  background-color: #314c63;
}

.secondary {
  background-color: #d4dce5;
  color: #ffffff;
  opacity: 0.8;
}

.secondary:hover {
  opacity: 1;
}

.modal-box {
  position: relative;
  background: #fff;
  border-radius: 12px;
  padding: 24px;
        box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
  width: 320px;
  text-align: center;
  animation: modal-appear 0.3s ease-out;
}

.close-button {
  position: absolute;
  top: 16px;
  right: 16px;
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: transform 0.2s ease;
}

.close-button:hover {
  transform: rotate(90deg);
}
</style>
